<template>
  <v-card data-qa="transferfundsaddnewpayee-card-12nn32">
    <v-toolbar color="white" light data-qa="transferfundsaddnewpayee-toolbar-2y6f5i">
      <v-toolbar-title data-qa="transferfundsaddnewpayee-toolbar-title-o3narn"  v-text="t.addPayeeHeading" />
      <v-spacer data-qa="transferfundsaddnewpayee-spacer-twniod"  />
      <v-btn
      v-if="isAddPayeePermitted"
        icon
        @click.stop="$emit('close-add-new-payee')"
       data-qa="transferfundsaddnewpayee-btn-299us4">
        <v-icon class="material-symbols-outlined" data-qa="transferfundsaddnewpayee-icon-8m155r">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider data-qa="transferfundsaddnewpayee-divider-ylzs4r"  />
    <v-container data-qa="transferfundsaddnewpayee-container-amb1pr">
      <v-form
        ref="form"
        v-model="form.isValid"
       data-qa="transferfundsaddnewpayee-form-vgxzczo">
        <v-text-field data-qa="transferfundsaddnewpayee-text-field-jfb25f" 
          v-model="form.accountName"
          :label="t.payeeAccountNameLabel"
          :color="primaryColor"
          :rules="[rules.required]"
          :maxlength="settings.maxlength ? settings.maxlength : false"
          filled
          class="transferFunds--custom-textfield"
        />
        <v-text-field data-qa="transferfundsaddnewpayee-text-field-7vl3s" 
          v-model="form.accountNumber"
          :label="t.payeeAccNoLabel"
          :color="primaryColor"
          :rules="[rules.required]"
          filled
          required
          type="password"
          @keydown="$formatter.validateNumberInput($event)"
          onCopy="return false"
          onpaste="return false"
          class="transferFunds--custom-textfield"
        />
        <v-text-field data-qa="transferfundsaddnewpayee-text-field-0aafhd" 
          v-model="form.accountNumberReentry"
          :label="t.payeeReEnterAccNoLabel"
          :color="primaryColor"
          :rules="[rules.required]"
          :error="!isAccountMatched"
          :error-messages="!isAccountMatched ? t.errorMsgAccNumMatch : ''"
          filled
          onCopy="return false"
          onpaste="return false"
          class="transferFunds--custom-textfield"
          @keydown="$formatter.validateNumberInput($event)"
        />
        <v-row no-gutters justify="start" class="pa-2" data-qa="transferfundsaddnewpayee-row-0pa3pl">
          <v-btn data-qa="transferfundsaddnewpayee-btn-9rkjn"
            @click="$emit('add-payee', form)"
            :color="primaryColor"
            :disabled="!form.isValid"
            class="white--text text-capitalize py-2 px-4"
            v-text="t.confirmAddPayee"
          />
        </v-row>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import '@/styles/pages/transferFunds.scss'
import store from '@/core/store'
export default {
  name: 'TransferFundsAddNewPayee',
  data () {
    return {
      rules: {
        required: (v) => Boolean(v) || this.$t('errors.common.requiredField')
      },
      form: {
        isValid: false,
        accountName: '',
        accountNumber: '',
        accountNumberReentry: ''
      },
      t: {
        addPayeeHeading: this.$t('transferfunds.addPayeeHeading'),
        payeeAccountNameLabel: this.$t('transferfunds.payeeAccountNameLabel'),
        payeeAccNoLabel: this.$t('transferfunds.payeeAccNoLabel'),
        payeeReEnterAccNoLabel: this.$t('transferfunds.payeeReEnterAccNoLabel'),
        errorMsgAccNumMatch: this.$t('transferfunds.errorMsgAccNumMatch'),
        confirmAddPayee: this.$t('transferfunds.confirmAddPayee')
      },
      settings: {
        maxlength: this.$appSettings.defaultConfigurations.payeeNameMaxlength.intraBank
      },
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  created () {
    this.permissions = store.getters['profileStore/profileData']?.permissions
  },
  computed: {
    isAccountMatched () {
      return this.form.accountNumber && this.form.accountNumberReentry
        ? this.form.accountNumber === this.form.accountNumberReentry
        : true
    },
    isAddPayeePermitted () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES') : true
    },
    isViewPayeePermitted () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('VIEW_PAYEES') : true
    }
  }
}
</script>
